import EppoFlags from '@/EppoFlags';
import {useBooleanAssignment} from '@/eppoHooks';

/**
 * The fulfillment-detail filters every `openOrders` caller must pass,
 * spread into the query's `variables`.
 */
const useOpenOrdersFulfillmentDetailFilters = () => {
  const onlyFulfillmentDetailsWithCarts = useBooleanAssignment(
    EppoFlags.DraftCartDropdownFulfillmentDetailsWithCarts,
  );

  return {onlyNonEmptyCarts: !onlyFulfillmentDetailsWithCarts, onlyFulfillmentDetailsWithCarts};
};

export default useOpenOrdersFulfillmentDetailFilters;
